/**
 * Compresse une image avant upload.
 * @param {File|Blob} file   fichier source
 * @param {number} maxDim    dimension max (largeur ou hauteur), défaut 900px
 * @param {number} quality   qualité JPEG 0-1, défaut 0.82
 * @returns {Promise<Blob>}  blob compressé
 */
export async function compressImage(file, maxDim = 900, quality = 0.82) {
  return new Promise((resolve) => {
    const img = new Image();
    const url = URL.createObjectURL(file);
    img.onload = () => {
      URL.revokeObjectURL(url);
      let { width, height } = img;
      if (width > maxDim || height > maxDim) {
        if (width > height) { height = Math.round(height * maxDim / width); width = maxDim; }
        else                { width  = Math.round(width  * maxDim / height); height = maxDim; }
      }
      const canvas = document.createElement('canvas');
      canvas.width  = width;
      canvas.height = height;
      canvas.getContext('2d').drawImage(img, 0, 0, width, height);
      canvas.toBlob(blob => resolve(blob || file), 'image/jpeg', quality);
    };
    img.onerror = () => resolve(file);
    img.src = url;
  });
}
